export default {
  fieldSet: {
    margin: [{
      title: '外边距-左',
      fieldName: 'marginLeft',
      direction: 'left',
      polygonPoints: '0 0, 0 15,5 12.7, 5 2.25',
      svgStyle: {
        basic: 'position:absolute',
        width: '15%',
        height: '100%',
        viewBox: '0 0 5 15'
      },
      width: '15%',
      height: '100%'
    }, {
      title: '外边距-右',
      fieldName: 'marginRight',
      direction: 'right',
      polygonPoints: '0 2.25, 0 12.7, 5,15, 5,0',
      svgStyle: {
        basic: 'position:absolute;right:0',
        width: '15%',
        height: '100%',
        viewBox: '0 0 5 15'
      }
    }, {
      title: '外边距-上',
      fieldName: 'marginTop',
      direction: 'top',
      polygonPoints: '0 0, 2.25 5, 12.7 5, 15,0',
      svgStyle: {
        basic: 'position:absolute',
        width: '100%',
        height: '15%',
        viewBox: '0 0 15 5'
      }
    }, {
      title: '外边距-下',
      fieldName: 'marginBottom',
      direction: 'bottom',
      polygonPoints: '0 5, 2.25 0, 12.7 0, 15,5',
      svgStyle: {
        basic: 'position:absolute;bottom:0',
        width: '100%',
        height: '15%',
        viewBox: '0 0 15 5'
      }
    }],
    padding: [{
      title: '内边距-左',
      fieldName: 'paddingLeft',
      direction: 'left',
      polygonPoints: '0 0, 0 15,5 11.25, 5 3.68',
      svgStyle: {
        basic: 'position:absolute',
        width: '20%',
        height: '100%',
        viewBox: '0 0 5 15'
      },
      width: '15%',
      height: '100%'
    }, {
      title: '内边距-右',
      fieldName: 'paddingRight',
      direction: 'right',
      polygonPoints: '0 3.68, 0 11.25,5 15, 5 0',
      svgStyle: {
        basic: 'position:absolute;right:0',
        width: '20%',
        height: '100%',
        viewBox: '0 0 5 15'
      }
    }, {
      title: '内边距-上',
      fieldName: 'paddingTop',
      direction: 'top',
      polygonPoints: '0 0, 3 5, 11.9 5, 15,0',
      svgStyle: {
        basic: 'position:absolute',
        width: '100%',
        height: '25%',
        viewBox: '0 0 15 5'
      }
    }, {
      title: '内边距-下',
      fieldName: 'paddingBottom',
      direction: 'bottom',
      polygonPoints: '0 5, 3 0, 11.9 0, 15,5',
      svgStyle: {
        basic: 'position:absolute;bottom:0',
        width: '100%',
        height: '25%',
        viewBox: '0 0 15 5'
      }
    }]
  }
};
export const PADDING_FIELD_SET = ['paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom'];
export const MARGIN_FIELD_SET = ['marginLeft', 'marginRight', 'marginTop', 'marginBottom'];
//# sourceMappingURL=uiData.js.map
